import { Grid, styled } from "@mui/material";

export const GridContainer = styled(Grid)(({ theme }) => ({}));

export const GridItem = styled(Grid)(({ theme }) => ({
	boxSizing: "border-box",
}));

export const Katex = styled("div")(({ theme }) => ({
	overflow: "auto",
	border: "1px solid grey",
	boxSizing: "border-box",
	padding: theme.spacing(0, 1),
}));
